import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
;;
import { Button, Columns, Column, MuiTitle, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal } from 'src/ui/mui-ui-kit';;;
import { connect } from 'react-redux';
import {
  FadeInDiv,
  AnimatedCard,
  InnerLoader,
  UiInputAdapter,
  UiQuillAdapter,
  reduceServerErrors,
  UiToastAdapter,
  UiFieldset,
} from 'src/ui';
import { format, startOfDay } from 'date-fns';
import { usePoseWithBulma } from 'src/ui/hooks';
import { toast } from 'react-toastify';
import { getUser } from 'src/user';
import { addAccountDocumentType, editAccountDocumentType } from 'src/account';
import { submitAndReset } from 'src/ui/util/submitAndReset';
import { composeValidators, required, number, date } from 'src/ui/validations';
import { cleanseInput, cleanseInt } from 'src/ui/util';
import arrayMutators from 'final-form-arrays';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UiToggleAdapter, UiSelectAdapter } from '../../ui';
import { DATE_MASK } from '../../ui/const';
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-no-bind */

const DOCUMENT_INTERVAL_FREQUENCY = [
  {
    value: 30,
    label: 'Month',
  },
  {
    value: 91,
    label: 'Quarter',
  },
  {
    value: 365,
    label: 'Year',
  },
];

function AddDocumentTypeModal({
  isActive,
  account,
  onClose,
  user,
  addAccountDocumentType,
  editAccountDocumentType,
  initialData,
  onArchiveType,
  reduceDocuments,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const [formData, setFormData] = useState({});
  const [toggleFreq, setToggleFreq] = useState('Once');
  const [isEdit, setIsEdit] = useState(false);
  const today = startOfDay(new Date());
  function onCancel(form = null) {
    if (form) {
      form.reset();
    }
    setFormData({});
    setIsEdit(false);
    setToggleFreq('Once');
    onClose();
  }
  useEffect(() => {
    const tempData = {
      name: '',
      description: '',
      Once: false,
      Custom: false,
      Expiration: false,
      uploadDays: null,
      startDate: null,
      Interval: false,
      intervalFrequency: null,
      needsApproval: false,
    };
    if (initialData) {
      /* eslint-disable no-restricted-syntax */
      for (const p in tempData) {
        if (p === initialData.frequencyType) {
          tempData[p] = true;
        } else {
          tempData[p] = initialData[p];
        }
      }
      if (tempData.Interval) {
        tempData.intervalFrequency = DOCUMENT_INTERVAL_FREQUENCY.find(
          el => el.value === parseInt(initialData.uploadDays, 10)
        );
      }
      setFormData(tempData);
      setToggleFreq(initialData.frequencyType || 'Once');
      setIsEdit(true);
    }
  }, [initialData]);
  async function onSubmit(values) {
    if (toggleFreq === 'Once') {
      values.frequency = 'Once';
    }
    if (toggleFreq === 'Custom') {
      values.frequency = 'Custom';
    }
    if (toggleFreq === 'Expiration') {
      values.frequency = 'Expiration';
    }
    if (toggleFreq === 'Interval') {
      values.frequency = 'Interval';

      values.uploadDays = values.intervalFrequency.value;
    }
    if (values.startDate) {
      values.startDate = format(values.startDate, 'YYYY-MM-DD');
    }

    if (isEdit) {
      await editAccountDocumentType({
        accountId: user.accountId,
        typeId: initialData.id,
        ...values,
      });
      reduceDocuments();
    } else {
      await addAccountDocumentType({
        accountId: user.accountId,
        ...values,
      });
    }

    if (account.isError()) {
      return reduceServerErrors(account);
    }
    toast(
      UiToastAdapter(
        isEdit
          ? 'Document type edit successful!'
          : 'Document type created successfully!',
        'success'
      )
    );
    onCancel();
    return undefined;
  }
  const onToggle = e => {
    return setToggleFreq(e.target.id);
  };

  const onArchive = () => {
    onArchiveType(initialData);
    onCancel();
  };
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={formData}
      mutators={{
        cleanse: ([event, cleansing], state, { changeValue }) => {
          cleanseInput(event, state, changeValue, cleansing);
        },
        ...arrayMutators,
      }}
      render={({ form, hasValidationErrors, submitting, handleSubmit }) => {
        const submit = submitAndReset(handleSubmit, form);

        return (
          <form onSubmit={submit} noValidate>
            <Modal
              isActive={isModalVisible}
              className="add-document-type-modal"
            >
              <ModalBackground
                tag={FadeInDiv}
                pose={currentPose}
                onPoseComplete={onPoseComplete}
              />
              <ModalCard tag={AnimatedCard} pose={currentPose}>
                <InnerLoader visible={submitting} />
                <ModalCardHeader>
                  <ModalCardTitle
                    tag="h5"
                    className="has-text-weight-semibold columns is-vcentered"
                  >
                    <Column tag="span" hasTextColor="primary" isPaddingless>
                      {isEdit ? 'Edit Document Type' : 'Add Document Type'}
                    </Column>
                    {isEdit && (
                      <Column isSize="narrow">
                        <Button
                          onClick={onArchive}
                          isColor="danger"
                          isPulled="right"
                        >
                          Archive
                        </Button>
                      </Column>
                    )}
                  </ModalCardTitle>
                </ModalCardHeader>
                <ModalCardBody>
                  <Field
                    component={UiInputAdapter}
                    id="name"
                    name="name"
                    label="Name"
                    required
                    validate={composeValidators('Name', required)}
                  />
                  <Field
                    component={UiQuillAdapter}
                    id="description"
                    name="description"
                    label="Description"
                    required
                    validate={composeValidators('Description', required)}
                  />
                  <Field
                    component={UiToggleAdapter}
                    id="needsApproval"
                    type="checkbox"
                    name="needsApproval"
                  >
                    Document Needs Approval on Upload
                  </Field>
                  <UiFieldset title="Document Upload Frequency">
                    <Columns isCentered>
                      <Column isSize="1/2">
                        <Field
                          component={UiToggleAdapter}
                          id="Once"
                          type="checkbox"
                          name="Once"
                          onChange={e => onToggle(e)}
                          checked={toggleFreq === 'Once'}
                        >
                          Once
                        </Field>
                        <Field
                          component={UiToggleAdapter}
                          id="Expiration"
                          type="checkbox"
                          name="Expiration"
                          onChange={e => onToggle(e)}
                          checked={toggleFreq === 'Expiration'}
                        >
                          Set Expiration Date on Upload
                        </Field>
                      </Column>
                      <Column isSize="1/2">
                        <Field
                          component={UiToggleAdapter}
                          id="Custom"
                          type="checkbox"
                          name="Custom"
                          onChange={e => onToggle(e)}
                          // disabled={toggleFreq === 'once' || toggleFreq === 'expiration' || toggleFreq !== null}
                          checked={toggleFreq === 'Custom'}
                        >
                          Custom Days
                        </Field>
                        <Field
                          component={UiToggleAdapter}
                          id="Interval"
                          type="checkbox"
                          name="Interval"
                          onChange={e => onToggle(e)}
                          checked={toggleFreq === 'Interval'}
                        >
                          Interval
                        </Field>
                      </Column>
                    </Columns>
                    {(toggleFreq === 'Custom' || toggleFreq === 'Interval') && (
                      <Columns isVCentered isGapless isCentered>
                        <Column isSize="narrow">
                          <MuiTitle isSize="6" style={{ marginRight: '10px' }}>
                            Upload Every{' '}
                          </MuiTitle>
                        </Column>
                        <Column isSize="1/4">
                          {toggleFreq === 'Custom' && (
                            <Field
                              component={UiInputAdapter}
                              id="uploadDays"
                              name="uploadDays"
                              label="Days"
                              required
                              onChange={e =>
                                form.mutators.cleanse(e, cleanseInt)
                              }
                              validate={composeValidators(
                                'Days',
                                required,
                                number({ min: 15, max: 1000 })
                              )}
                            />
                          )}
                          {toggleFreq === 'Interval' && (
                            <Field
                              component={UiSelectAdapter}
                              id="intervalFrequency"
                              type="dropdown"
                              name="intervalFrequency"
                              label="Interval"
                              options={DOCUMENT_INTERVAL_FREQUENCY}
                              getOptionLabel={item => item.label}
                              getOptionValue={item => item.value}
                              required
                              validate={composeValidators('Interval', required)}
                              // onFocus={() => setHandleChange(true)}
                            />
                          )}
                        </Column>
                        <Column isSize="narrow">
                          <MuiTitle
                            isSize="6"
                            style={{ marginRight: '10px', marginLeft: '10px' }}
                          >
                            Starting On{' '}
                          </MuiTitle>
                        </Column>
                        <Column isSize="1/3">
                          <Field
                            component={UiInputAdapter}
                            name="startDate"
                            id="startDate"
                            label="Date"
                            mask={DATE_MASK}
                            required
                            hasIcons="right"
                            defaultValue={format(today, 'MM-DD-YYYY')}
                            validate={composeValidators('Date', required, date)}
                            renderIcons={() => [
                              <span className="icon is-right" key="right-icon">
                                <FontAwesomeIcon
                                  icon={['fal', 'calendar-alt']}
                                />
                              </span>,
                            ]}
                          />
                        </Column>
                      </Columns>
                    )}
                  </UiFieldset>

                  <div className="buttons is-centered">
                    <Button hasTextColor="info" onClick={() => onCancel(form)}>
                      Cancel
                    </Button>
                    <Button
                      isColor="gradient-bright"
                      disabled={hasValidationErrors}
                      type="submit"
                    >
                      {isEdit ? 'Submit' : 'Create Document Type'}
                    </Button>
                  </div>
                </ModalCardBody>
              </ModalCard>
            </Modal>
          </form>
        );
      }}
    />
  );
}
AddDocumentTypeModal.defaultProps = {
  initialData: null,
};
AddDocumentTypeModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  addAccountDocumentType: propTypes.func.isRequired,
  editAccountDocumentType: propTypes.func.isRequired,
  account: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  initialData: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  onArchiveType: propTypes.func.isRequired,
  reduceDocuments: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedAddDocumentTypeModal = connect(mapStateToProps, {
  addAccountDocumentType,
  editAccountDocumentType,
})(AddDocumentTypeModal);

export { connectedAddDocumentTypeModal as AddDocumentTypeModal };
